export default "__VITE_ASSET__BQmB_xb___"